import React from "react";
import { observer, useLocalStore } from "mobx-react";
import MyDatePicker from "../input/MyDatePicker";
import theme from "../layout/theme";
import MakeQuote from "./MakeQuote";
import QuoteTabel from "./QuoteTabel";
import { toast } from "react-toastify";
import { useEffect } from "react";
import NumberEditor from "../input/NumberEditor";
import { makeStyles } from "@mui/styles";
import useDocumentTitle from "../layout/title";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import apiCall from "../../scripts/apiCall";
import { useMsal } from "@azure/msal-react";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { EOCSwitch } from "../input/EOCSwitch";

const useStyles = makeStyles({
  row: {
    fontWeight: "bold",
    background: theme.palette.primary.light,
    "& td": { fontSize: "medium", fontWeight: "bold" },
  },
  row2: {
    "& th": { fontWeight: "bolder", color: theme.palette.secondary.light },
  },
  row1: {
    fontWeight: "bold",
    background: theme.palette.secondary.light,
    "& td": { fontSize: "medium", fontWeight: "bold" },
  },
  row3: {
    "& th": { fontWeight: "bolder", color: theme.palette.primary.light },
  },
});

export default observer(({ store }) => {
  const { instance, accounts } = useMsal();
  console.log("Quotations.jsx");
  var sys = window.localStorage.getItem("QUOTEsys");

  useDocumentTitle("Quotes " + sys);
  const classes = useStyles();
  const lstore = useLocalStore(() => ({
    activeQ: false,
    selected: -1,
    type: "",
    tryToSave: false,
    sortdir: 1,
    sortpar: "Validfrom", //"ValidTo"
  }));
  console.log(lstore.activeQ);
  useEffect(() => {
    let sort = window.localStorage.getItem("QuoteSort");

    if (sort !== undefined && sort !== null) {
      const sortObj = JSON.parse(sort);
      lstore.sortdir = sortObj.dir;
      lstore.sortpar = sortObj.par;
    }
    apiCall(
      "Quote/GetShipInco",
      {
        method: "GET",
      },
      (results) => {
        console.log(results);
        const obj = {};
        results
          .filter((e) => e.Name !== "Views")
          .forEach((el) => {
            obj[el.name.trim()] = el.description
              .replace(/<\/?p>/g, "")
              .split(",");
          });
        store.setRelation(obj);
      },
      instance,
      accounts
    );

    let url = `SAPOData${sys}/V4`;
    apiCall(
      url,
      {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({
          sb: "zapi_local_interf_sb",
          proj: "zapi_local_interf_sd",
          funct: "locationHelp",
          //parameters: `$format=json`,
          parameters: `$filter=spras eq 'EN'`,
          version: "0001",
        }),
      },
      (results) => {
        console.log(results);
        console.log(results.value);
        const obj = {};
        results.value.forEach((el) => {
          obj[el.descr40.trim()] = el.Locno;
        });
        store.setInco2(obj);
      },
      instance,
      accounts
    );
  }, []);
  return (
    <Box m={1} p={1} style={{ background: "white" }}>
      {lstore.type === "" && (
        <TableContainer>
          <Table size={"small"}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <h3>Sold to</h3>
                </TableCell>
                <TableCell>
                  <h3>Ship to</h3>
                </TableCell>
                <TableCell>
                  <h3>Payer</h3>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                key={
                  store.SSPItem.Payer +
                  store.SSPItem.ShipTo +
                  store.SSPItem.SoldTo
                }
              >
                <TableCell>
                  ({store.SSPItem.SoldTo}) {store.SSPItem.SoldToName}
                </TableCell>
                <TableCell>
                  <p>
                    ({store.SSPItem.ShipTo}) {store.SSPItem.ShipToName}
                  </p>
                  [{store.SSPItem.ShipToCountry} {store.SSPItem.ShipToPostcode}{" "}
                  {store.SSPItem.ShipToLocation}]
                </TableCell>
                <TableCell>
                  ({store.SSPItem.Payer}) {store.SSPItem.PayerName}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {lstore.type === "" && (
        <Box m={1} p={1} style={{ background: "white" }}>
          <Button
            variant="outlined"
            onClick={(e) => {
              store.selectQuote({
                Shiptonr: store.SSPItem.ShipTo,
                Shiptoname: store.SSPItem.ShipToName,
                Soldtonr: store.SSPItem.SoldTo,
                Soldtoname: store.SSPItem.SoldToName,
                Salesorg: store.SSPItem.SalesOrg,
                Incoterm1: store.SSPItem.DefaultIncoterm1,
                Incoterm2: store.SSPItem.DefaultIncoterm2,
                Paymentterm: store.SSPItem.DefaultPaymentterm,
                Shipmentterm: store.SSPItem.DefaultShipmentterm,
                Currency: store.SSPItem.DefaultCurrency,
                toCustomer: false,
              });
              lstore.type = "new";
            }}
            color="secondary"
          >
            Create New quote
          </Button>{" "}
          or Search and click on a QuoteNr below to create with reference
          <Grid container m={2}>
            <Grid item xs={12} sm={10} md="auto">
              <MyDatePicker
                title="Date"
                updatefunc={store.quoteData.setDate}
                value={store.quoteData.date}
                format="DD-MM-YYYY"
              />
            </Grid>
            <Grid item xs={12} md p={1} paddingTop={3}>
              <Button
                color="primary"
                variant="contained"
                onClick={(e) => {
                  e.preventDefault();
                  store.quoteData.getQuotes(
                    store.SSPItem.SoldTo,
                    store.SSPItem.ShipTo
                  );
                }}
              >
                Get quotes on Date
              </Button>
            </Grid>
            <Grid item xs={12} sm={10} md="auto">
              <NumberEditor
                title="#"
                updatefunc={store.quoteData.setNr}
                value={store.quoteData.Nr}
              />
            </Grid>
            <Grid item xs={12} md p={1.5} paddingTop={3}>
              <Button
                color="primary"
                variant="contained"
                onClick={(e) => {
                  e.preventDefault();
                  store.quoteData.getLastQuotes(
                    store.SSPItem.SoldTo,
                    store.SSPItem.ShipTo
                  );
                }}
              >
                Get last {store.quoteData.Nr} quotes
              </Button>
            </Grid>{" "}
            <Grid item xs={12} md p={1.5} paddingTop={3}>
              Valid From{" "}
              <EOCSwitch
                checked={lstore.sortpar === "ValidTo"}
                onChange={({ target }) => {
                  if (target.checked) lstore.sortpar = "ValidTo";
                  else lstore.sortpar = "Validfrom";
                  window.localStorage.setItem(
                    "QuoteSort",
                    JSON.stringify({ dir: lstore.sortdir, par: lstore.sortpar })
                  );
                }}
              />{" "}
              Valid To
              <Button
                color="secondary"
                variant="outlined"
                onClick={(e) => {
                  lstore.sortdir = lstore.sortdir * -1;
                  window.localStorage.setItem(
                    "QuoteSort",
                    JSON.stringify({ dir: lstore.sortdir, par: lstore.sortpar })
                  );
                }}
              >
                {lstore.sortdir === 1 ? <ArrowUpward /> : <ArrowDownward />}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <QuoteTabel classes={classes} store={store} lstore={lstore} />
              <Dialog
                open={
                  (lstore.activeQ || lstore.selected >= 0) && lstore.type === ""
                }
                onClose={(e) => {
                  lstore.selected = -1;
                  lstore.activeQ = false;
                }}
              >
                <DialogActions>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      var q = null;
                      if (lstore.activeQ) {
                        q = store.quoteData.ActiveQuote;
                      } else {
                        q = store.quoteData.Quotes.slice().sort((a, b) => {
                          var i = -1;
                          if (a[lstore.sortpar] > b[lstore.sortpar]) {
                            i = 1;
                          }
                          return i * lstore.sortdir;
                        })[lstore.selected];
                      }
                      store.selectQuote({
                        ...q,
                        ReqDel: new Date(q.ReqDel).getTime(),
                        Validfrom: new Date(q.ValidTo).setDate(
                          q.ValidTo.getDate() + 1
                        ),
                        ValidTo: null,
                        Items: q.Items.map((qel) => ({
                          ...qel,
                          Oldprice: qel.PricePerTon,
                          PricePerTon: "",
                        })),
                      });
                      lstore.type = "copy";
                    }}
                  >
                    Copy
                  </Button>

                  <Button
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      var q = null;
                      if (lstore.activeQ) {
                        q = store.quoteData.ActiveQuote;
                      } else {
                        q = store.quoteData.Quotes.slice().sort((a, b) => {
                          var i = -1;
                          if (a[lstore.sortpar] > b[lstore.sortpar]) {
                            i = 1;
                          }
                          return i * lstore.sortdir;
                        })[lstore.selected];
                      }
                      store.selectQuote({
                        ...q,
                        ReqDel: new Date(q.ReqDel).getTime(),
                        Validfrom: new Date(q.ValidTo).setDate(
                          q.ValidTo.getDate() + 1
                        ),
                        ValidTo: null,
                        toCustomer: false,
                      });
                      lstore.type = "extend";
                    }}
                  >
                    extend
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={(e) => {
                      var q = null;
                      if (lstore.activeQ) {
                        q = store.quoteData.ActiveQuote;
                      } else {
                        q = store.quoteData.Quotes.slice().sort((a, b) => {
                          var i = -1;
                          if (a[lstore.sortpar] > b[lstore.sortpar]) {
                            i = 1;
                          }
                          return i * lstore.sortdir;
                        })[lstore.selected];
                      }
                      store.selectQuote({
                        ...q,
                        Validfrom: new Date(q.Validfrom).getTime(),
                        ValidTo: new Date(q.ValidTo).getTime(),
                        ReqDel: new Date(q.ReqDel).getTime(),
                        toCustomer: false,
                        Items: q.Items.map((qel) => ({
                          ...qel,
                          Oldprice: qel.PricePerTon,
                          PricePerTon: "",
                        })),
                      });
                      lstore.type = "replace";
                    }}
                  >
                    replace
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>
        </Box>
      )}
      {lstore.type !== "" && (
        <Box>
          <MakeQuote
            trySave={lstore.tryToSave}
            store={store}
            quote={store.SelectedQuote}
            type={lstore.type}
          />
          <Button
            color="secondary"
            variant="outlined"
            size="large"
            style={{ float: "right" }}
            onClick={(e) => {
              if (store.SelectedQuote.validShipInco) {
                if (store.SelectedQuote.validInco2) {
                  if (store.SelectedQuote.canSave) {
                    store.make(lstore.type);
                  } else {
                    toast.warn("not everything is filled in");
                    lstore.tryToSave = true;
                  }
                } else {
                  toast.warn("Inco2 not correct");
                  lstore.tryToSave = true;
                }
              } else {
                toast.error("not a valide shipment- and incoterm combination");
                lstore.tryToSave = true;
              }
            }}
          >
            {lstore.type === "new" ? "make " : "" + lstore.type} quote
          </Button>
        </Box>
      )}
      <Button
        color="primary"
        variant="contained"
        size="small"
        onClick={(e) => {
          e.preventDefault();
          if (lstore.type === "") {
            store.quoteData.setDate(new Date());
            store.selectSSP(-1);
            store.quoteData.setQuotes([]);
          } else {
            lstore.type = "";
            lstore.selected = -1;
            store.selectQuote(null);
          }
        }}
      >
        Back
      </Button>
    </Box>
  );
});
